'use strict';

import React, { useState } from 'react';
import PageFrame, { PHONE } from '../becomeApplicantV2/PageFrame';
import InvoiceFinancingV2Process from './invoiceFinancingV2Process';
import { parseInvoiceParams } from './invoiceContext';

/**
 * New laskurahoitus (invoice financing) application flow (/hae-laskurahoitusta).
 * Same page frame, components and styles as the yrityslaina v2 form; the live
 * invoiceFinancing/ flow is not touched.
 */

// Same guidance the live invoice financing form shows under the application.
const afterForm = (
  <>
    <p>Oletko hakemassa yrityslainaa? Voit siirtyä yrityslainahakemukseen <a href="/hae-yrityslainaa">tästä</a>.</p>
    <p>Jos olet jo asiakkaamme, voit kirjautua sivuillesi <a href="https://app.kasvurahoitus.fi/login">tästä</a>. Asiakaspalvelumme on tavoitettavissa puhelimitse numerossa <a href={PHONE.href}>{PHONE.intl}</a> (ark. klo 9-16) ja sähköpostitse osoitteessa <a href="mailto:laskurahoitus@kasvurahoitus.fi">laskurahoitus@kasvurahoitus.fi</a>.</p>
  </>
);

export default function InvoiceFinancingV2({ match, history }) {
  const context = parseInvoiceParams(match, history && history.location ? history.location.search : '');
  const [step, setStep] = useState(1);
  return (
    <PageFrame
      promo={<>Laskurahoitus 2 minuutissa, <strong>vapauta sidottu pääoma välittömästi!</strong></>}
      contactEmail="laskurahoitus@kasvurahoitus.fi"
      afterForm={step === 1 ? afterForm : null}
    >
      <InvoiceFinancingV2Process context={context} onStepChange={setStep} />
    </PageFrame>
  );
}
